import { ca } from '@cian/analytics';

import { EDeviceType } from '../../types/device';
import { TOfferPin } from '../../types/map';

export function trackInfrastructureClick(offerPins: TOfferPin[], label: string) {
  const products = offerPins.map(offerPin => ({ id: offerPin.realtyOfferId }));

  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'click_infrastructure_show_sopr',
    label,
    page: {
      listingType: 'list',
      pageType: 'ListingFavorites',
      siteType: EDeviceType.Desktop,
    },
    products,
  });
}

export function trackGeoClick(productId: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'click_pin_sopr',
    label: '',
    page: {
      listingType: 'list',
      pageType: 'ListingFavorites',
      siteType: EDeviceType.Desktop,
    },
    products: [{ id: productId }],
  });
}
